import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode } from "vue"

import type { Ref } from 'vue';
import { useSlots } from 'vue';
import type { SelectItem, SelectItemSeparator } from '../../lib/list-selection/types';
import { useListMultipleSelect, useListSelect } from '../../lib/list-selection';
import { BaseList, BaseSelectItem, BaseSelectSeparator } from './index';

type Props = {
  items: (Item | SelectItemSeparator)[];
  gap?: number;
  showCheckbox?: boolean;
  pageMode?: boolean;
  multiline?: boolean;
  disabled?: boolean;
  multiple?: boolean;
};

type Id = Item['id'];

type ModelValue<Multiple extends boolean> = Multiple extends true
  ? Id[]
  : Id;


export default /*@__PURE__*/_defineComponent({
  __name: 'base-select-list',
  props: /*@__PURE__*/_mergeModels({
    items: {},
    gap: { default: 0 },
    showCheckbox: { type: Boolean },
    pageMode: { type: Boolean },
    multiline: { type: Boolean },
    disabled: { type: Boolean },
    multiple: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["itemClick"], ["update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const value = _useModel<ModelValue<Multiple>>(__props, "modelValue");

const {
  onHover,
  toggle,
  selectableItems,
  hoveredIndex,
  hoveredFromKeyboard
} = props.multiple
  ? useListMultipleSelect({
      items: () => props.items,
      modelValue: value as Ref<Id[]>,
      onChange: (ids: Id[]) => {
        value.value = ids;
      }
    })
  : useListSelect({
      items: () => props.items,
      required: true,
      modelValue: value as Ref<Id>,
      useKeyboardEvents: true,
      onChange: (id: Id) => {
        value.value = id;
      }
    });

const slots = useSlots();

function isSeparator(item: any): item is SelectItemSeparator {
  return item.type === 'separator';
}

__expose({ hoveredIndex });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseList), {
    gap: __props.gap,
    "data-qa": "dropdown-list",
    "page-mode": __props.pageMode,
    "scroll-to-active-index": _unref(hoveredFromKeyboard),
    "active-index": _unref(hoveredIndex),
    items: _unref(selectableItems)
  }, {
    item: _withCtx(({ index, item }) => [
      (isSeparator(item))
        ? (_openBlock(), _createBlock(_unref(BaseSelectSeparator), {
            key: 0,
            label: item.label
          }, null, 8, ["label"]))
        : _renderSlot(_ctx.$slots, "item", {
            key: 1,
            item: item,
            index: index,
            onHover: _unref(onHover),
            toggle: _unref(toggle)
          }, () => [
            _createVNode(_unref(BaseSelectItem), {
              title: item.name,
              description: item.description,
              icon: item.icon,
              disabled: item.disabled,
              "data-qa": item.dataQa || 'list-item',
              "show-checkbox": __props.showCheckbox,
              multiline: __props.multiline,
              hovered: item.userSelection.hovered,
              selected: item.userSelection.selected,
              onClick: ($event: any) => {emit('itemClick', item); _unref(toggle)(item)},
              onMouseenter: ($event: any) => (_unref(onHover)(index))
            }, _createSlots({ _: 2 }, [
              _renderList(_unref(slots), (_, name) => {
                return {
                  name: name,
                  fn: _withCtx(() => [
                    _renderSlot(_ctx.$slots, name, { item: item })
                  ])
                }
              })
            ]), 1032, ["title", "description", "icon", "disabled", "data-qa", "show-checkbox", "multiline", "hovered", "selected", "onClick", "onMouseenter"])
          ])
    ]),
    _: 3
  }, 8, ["gap", "page-mode", "scroll-to-active-index", "active-index", "items"]))
}
}

})